"use strict";

//export const MainPath = "http://sprintto-001-site1.itempurl.com";
export const MainPath = "http://localhost:9999";
export const BaseUrl = "http://localhost:9999";
////////////////////////////////////////////////////////////////////


// localhost
   //export const bashost = "http://localhost:9999";
   //export const frontHost = 'http://localhost:4200/';

////

// Ali AlGhanim
// ng build --prod --base-href /./ --deploy-url /./
// export const frontHost = 'https://acservices.ali-alghanim.net/';
// export const bashost = 'https://acservices.ali-alghanim.net/servioBackend';



// EDC On Azure Amanah
// ng build --prod --base-href /./ --deploy-url /./
//export const frontHost = 'http://52.224.240.66:8090/';
//export const bashost = "http://52.224.240.66:8090//edcback/";


// EDC Live Domain
// ng build --prod --base-href /./ --deploy-url /./
//export const frontHost = 'https://edcmaint.com/';
//export const bashost = "https://edcmaint.com/edcback/";



// Naseem Uat External
// ng build -c production --base-href /uatfrontend/ --deploy-url /uatfrontend/
//export const frontHost = "https://serv.naseem-gt.com/uatfrontend";
//export const bashost = "https://serv.naseem-gt.com/uatbackend";


// Naseem Uat local
// ng build --prod --base-href /UATLocal/ --deploy-url /UATLocal/
//export const frontHost = 'https://192.168.21.20/uatlocal';
//export const bashost = "https://192.168.21.20/uatbackend/";

//Alfa UAT - Live Now
//ng build --prod --base-href /UATFrontend/ --deploy-url /UATFrontend/
//export const bashost = 'http://62.215.242.6//uatbackend';
//export const frontHost = 'http://62.215.242.6:8082/uatfrontend'

//Alfa Live
//ng build --prod --base-href /./ --deploy-url /./
// export const bashost = 'https://sm.alfacontract.com/backend';
// export const frontHost = 'https://sm.alfacontract.com/'

//Alfa Test
//ng build --prod --base-href /TestFront/ --deploy-url /TestFront/
//export const bashost = 'https://sm.alfacontract.com/testback';
//export const frontHost = 'https://sm.alfacontract.com/testfront'


// Staging AllEnv On Amanah Server
// ng build --prod --base-href /maintenancefront-staging/ --deploy-url /maintenancefront-staging/
//  export const frontHost ='https://e-amanahkwt.com/maintenancefront-staging/';
//  export const bashost = 'https://e-amanahkwt.com/maintenanceback-staging';


// Naseem Live External
//ng build -c production --base-href /naseemfront/ --deploy-url /naseemfront/
//export const frontHost = 'https://serv.naseem-gt.com/naseemfront';
//export const bashost = "https://serv.naseem-gt.com/backend/";

// Naseem Live Internal
//ng build -c production --base-href /frontend/ --deploy-url /frontend/
//export const frontHost = 'http://192.168.21.20:8080/frontend';
//export const bashost = "http://192.168.21.20:8080/backend/";

//Gulf UAT
//ng build --prod --base-href /UATFrontend/ --deploy-url /UATFrontend/
//export const bashost = 'https://app.gulfengg.com/uatbackend';
//export const frontHost = 'https://app.gulfengg.com/uatfrontend/'


//Gulf UAT Local
//ng build --prod --base-href /UATLocal/ --deploy-url /UATLocal/
//export const bashost = 'https://192.168.1.10/uatbackend';
//export const frontHost = 'https://192.168.1.10/uatlocal/'

//Gulf Live
//ng build --prod --base-href /osmfrontend/ --deploy-url /osmfrontend/
//export const bashost = 'https://app.gulfengg.com/osmbackend';
//export const frontHost = 'https://app.gulfengg.com/osmfrontend/'

//Gulf Live Loca
//ng build --prod --base-href /localgulffront/ --deploy-url /localgulffront/
//export const bashost = 'https://192.168.1.10/osmbackend';
//export const frontHost = 'https://192.168.1.10/localgulffront/'

//Alfa UAT
//ng build --prod --base-href /UATFrontend/ --deploy-url /UATFrontend/
//export const bashost = 'http://62.215.242.6//uatbackend';
//export const frontHost = 'http://62.215.242.6:8082/uatfrontend'

//Gulf Demo Local
//ng build --prod --base-href /DemoLocal/ --deploy-url /DemoLocal/
//export const bashost = 'https://192.168.1.10/DemoBackend';
//export const frontHost = 'https://192.168.1.10/DemoLocal/'

//Aly El Ghanem - New Environment
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'https://acservices.ali-alghanim.net/servioBackend';
//export const frontHost = 'https://acservices.ali-alghanim.net/'

//Staging Azure
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://52.224.240.66:8094/StagingBackend';
//export const frontHost = 'http://52.224.240.66:8094/'

//Alfa Test
//ng build --prod --base-href /TestFront/ --deploy-url /TestFront/
//export const bashost = 'https://sm.alfacontract.com/testback/';
//export const frontHost = 'https://sm.alfacontract.com/testfront/'


//Al Essa Live URL
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://maintenance.alessa-group.com:8091/serviobackend';
//export const frontHost = 'http://maintenance.alessa-group.com:8091/'


//Al Essa Live URL SSl
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://maintenance.alessa-group.com/serviobackend';
//export const frontHost = 'https://maintenance.alessa-group.com'

//Al Fajr
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://52.224.240.66:8092/servioBackend';
//export const frontHost = 'http://52.224.240.66:8092/'


//staging without payment
////ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'http://5.9.68.149:9006/backend';
// export const frontHost = 'https://servio-staging.amnapps.com/'

//staging with payment
//ng build --prod --base-href /./ --deploy-url /./
// export const bashost = 'http://65.21.22.201:8094/StagingBackend';
// export const frontHost = 'http://65.21.22.201:8094/'

//New Al Essa Live URL
//ng build --prod --base-href /./ --deploy-url /./
// export const bashost = 'https://maintenance.alessa-group.com/serviobackend';
// export const frontHost = 'https://maintenance.alessa-group.com/'

//Fajir El Eman
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'https://a.alemanco.com/serviobackend';
//export const frontHost = 'https://a.alemanco.com/'

//Fajir Live Latest https://fajr.alemanco.com/
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'https://fajr.alemanco.com/serviobackend';
//export const frontHost = 'https://fajr.alemanco.com/'

//Romac
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://5.9.112.70:8086/serviobackend';
//export const frontHost = 'http://5.9.112.70:8086/'

//Romac Live New Server
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'https://maintenance.q8romac.com/serviobackend';
// export const frontHost = 'https://maintenance.q8romac.com/'


//Hayat
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://5.9.112.70:8087/serviobackend/';
//export const frontHost = 'http://5.9.112.70:8087/'

//EDCUAT
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://uat.edcprojects.com/edcBack';
//export const frontHost = 'https://uat.edcprojects.com/'

//EDC
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://edcprojects.com/edcback';
//export const frontHost = 'https://edcprojects.com/'

//Hayat SSL
//ng build --prod --base-href /./ --deploy-url /./
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://hayatacmaint.com/serviobackend'
//export const frontHost = 'https://hayatacmaint.com/'

//Staging Payment
//ng build --prod --base-href /./ --deploy-url /./
// export const bashost = 'https://servio-payment-staging.amnapps.com/StagingBackend/'
// export const frontHost = 'https://servio-payment-staging.amnapps.com/'

//Alfa Test Internal New Server
//ng build --prod --base-href /./ --deploy-url /./
//export const bashost = 'http://192.168.10.86:8082/backend/';
//export const frontHost = 'http://192.168.10.86:8082/'

//Staging without paymentPayment
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://servio-staging.amnapps.com/backend'
//export const frontHost = 'https://servio-staging.amnapps.com/'
//Taskeen
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'http://5.9.68.149:9008/backend';
// export const frontHost = 'http://5.9.68.149:9008/'
//Alain
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'http://5.9.68.149:9009/backend';
// export const frontHost = 'http://5.9.68.149:9009/'

//Alfa Live
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'https://app.alfacontract.com/backend';
// export const frontHost = 'https://app.alfacontract.com/'

//ahmadia dev
////ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'https://elevator-dev.amnapps.com/backend';
// export const frontHost = 'https://elevator-dev.amnapps.com/'


//Elevetor dev
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'http://5.9.68.149:9006/backend';
//export const frontHost = 'http://5.9.68.149:9006/'


//Sky Elevator External
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'https://skyelev.amnapps.com/backend';
//export const frontHost = 'https://skyelev.amnapps.com/'

//Sky Elevator Dev
//ng build -c production --base-href /./ --deploy-url /./
export const bashost = 'https://skyelev-dev.amnapps.com/backend';
export const frontHost = 'https://skyelev-dev.amnapps.com/'
//United Dev
//ng build -c production --base-href /./ --deploy-url /./
//  export const bashost = 'https://united-uat.amnapps.com/backend';
//  export const frontHost = 'https://united-uat.amnapps.com/'

//United Production
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'http://37.34.236.95:9001/backend';
// export const frontHost = 'http://37.34.236.95:9001/'

//United Live
//ng build -c production --base-href /./ --deploy-url /./
// export const bashost = 'https://unitedelevators-maint.com/backend';
// export const frontHost = 'https://unitedelevators-maint.com/'

//ahmadia Live
//ng build -c production --base-href /./ --deploy-url /./
//export const bashost = 'http://37.34.226.32:9002/stagingbackend';
//export const frontHost = 'http://37.34.226.32:9002/'

//ahmadia Live Loca
//ng build -c production --base-href /localfront/ --deploy-url /localfront/
// export const bashost = 'http://192.168.5.177:9002/stagingbackend';
// export const frontHost = 'http://192.168.5.177:9002/localfront/'


export const showInvoiceReportSpareColumns = true;

export const BaseUrlIdentity = `${bashost}/api/`;
export const BaseUrlDataManagement = BaseUrlIdentity;
export const BaseUrlUserManagementNew = BaseUrlIdentity;
export const BaseUrlOrderManagementNew = BaseUrlIdentity;
export const BaseUrlLocation = BaseUrlIdentity;
export const BaseUrlDropout = bashost;


export const x = "";

export function testFunc(test) {
  this.x = test;
}


// http://localhost/EnmaaEstimationQuotation/quotationHub?userId=' + userId + '&&roles=' + roles + '&&token=' + token

/***************************************/
export const orderStatus = BaseUrlOrderManagementNew + "orderStatus/getAll";
export const orderProgressUrl = "OrderAction/GetOrderProgress/";
export const orderProgresWithOffesetsUrl = "OrderAction/GetOrderProgressByOrderId";
export const addUserDeviceUrl = "User/AddUserDevice";
export const allProbs = "Lang_OrderProblem/GetAll";
export const allProbsLocalized = "Lang_OrderProblem/GetAllLanguages";
export const addProbURL = "OrderProblem/Add";
export const allAreasDispatcher = BaseUrlDataManagement + "Areas/GetAll";
export const allOrderProblemsUrl =
  BaseUrlOrderManagementNew + "OrderProblem/GetAll";


export const postOrderTypeUrl = BaseUrlOrderManagementNew + "OrderType/Add"; // Json mocking
export const postOrderStateUrl = BaseUrlOrderManagementNew + "OrderStatus/Add"; // Json mocking
export const getOrdersByDis = "Order/GetMapOrdersForDispatcher?dispatcherId=";
// dispatcher map filter api
export const postMapOrderFilterURL = "Order/OrderFilterMap";
// dispatcher board filter api
export const postBoardOrderFilterURL = "Order/assignedOrdersBoardFilter";
export const postAllOrdersBoardOrderFilterURL =
  "Order/GetAllOrdersForDispatcherFilter";

export const postUnassignedOrdersBoardFilterURL =
  "Order/UnassignedOrdersBoardFilter";
// ***********************filter preventive***************
export const postOrderProblems = BaseUrlOrderManagementNew + "OrderProblem/Add";
export const removeProblemUrl =
  BaseUrlOrderManagementNew + "OrderProblem/Delete/";
export const deleteOrderStatusUrl =
  BaseUrlOrderManagementNew + "OrderStatus/Delete/"; // Json mocking
export const deleteOrderTypeUrl =
  BaseUrlOrderManagementNew + "OrderType/Delete/"; // Json mocking
export const updateOrderStatusUrl =
  BaseUrlOrderManagementNew + "OrderStatus/Update";
export const updateOrderTypeUrl =
  BaseUrlOrderManagementNew + "OrderType/Update";
export const updateOrderProgressUrl =
  BaseUrlOrderManagementNew + "ProgressStatus/Update";
export const updateOrderProblemsUrl =
  BaseUrlOrderManagementNew + "OrderProblem/Update";

//*************************************************************
//*************************************************************
//*************************************************************
// -------------------- Customers URLs ------------------------

// export const SearchCustomer = MainPath + '/api/customer/SearchCustomer?searchToken=';
export const CreatenewCustomer =
  MainPath + "/api/customer/CreateDetailedCustomer";
// export const GetCustomerDetailsByID = MainPath + '/api/customer/CustomerHistory/';
export const EditCustomerInfo = MainPath + "/api/customer/Update";
export const EditContract = MainPath + "/api/contract/Update";
export const ExtendContract = "contract/Extend";
export const AddContract = MainPath + "/api/contract/add";

export const AddNewWorkOrder = MainPath + "/api/WorkOrder/AddWorkOrder";
export const AddLocation = MainPath + "/api/location/add";

export const EditComplain = MainPath + "/api/complain/Update";
export const AddComplain = MainPath + "/api/complain/add";
export const EditWorkOrder = MainPath + "/api/WorkOrder/EditWorkOrder";
export const customerAddresses = "Customer/Get/";
export const getCustomerDetailsWithPagedLocations = 'Customer/GetCustomerInfoWithPagedLocations/';


//-------------------- Lookups URls -----------------------------
export const allCustomerTypes = MainPath + "/api/CustomerType/getall";
export const allContractType = MainPath + "/api/ContractType/getall";
export const allWorkItems = MainPath + "/api/Item/GetAll";
// export const allLocation = MainPath + '/api/location/getall';
export const allFactories = MainPath + "/api/Factory/GetAll";
// export const allGovernorates = MainPath + '/api/location/GetAllGovernorates';

// export const allAreas = MainPath + '/api/location/GetAreas';
// export const allBlocks = MainPath + '/api/location/GetBlocks';
// export const allStreets = MainPath + '/api/location/GetStreets';
// export const allGetLocationByPaci = MainPath + '/api/location/GetLocationByPaci?paciNumber=';
export const allStatus = MainPath + "/api/Status/getall";

export const editStatus = MainPath + "/api/Status/Update";
export const AddStatus = MainPath + "/api/Status/Add";
export const DeleteStatus = MainPath + "/api/Status/Delete";

export const allRole = MainPath + "/api/Role/getall";
export const editRole = MainPath + "/api/Role/Update";
export const AddRole = MainPath + "/api/Role/Add";
export const DeleteRole = MainPath + "/api/Role/Delete";

export const allPeriorities = MainPath + "/api/Priority/getall";
export const editPeriorities = MainPath + "/api/Priority/Update";
export const AddPeriorities = MainPath + "/api/Priority/Add";
export const DeletePeriorities = MainPath + "/api/Priority/Delete";

export const editCustomerType = MainPath + "/api/CustomerType/Update";
export const AddCustomerType = MainPath + "/api/CustomerType/Add";
export const DeleteCustomerType = MainPath + "/api/CustomerType/Delete";

export const editContractType = MainPath + "/api/ContractType/Update";
export const AddContractType = MainPath + "/api/ContractType/Add";
export const DeleteContractType = MainPath + "/api/ContractType/Delete";

export const allEquipmentType = MainPath + "/api/EquipmentType/getall";
export const editEquipmentType = MainPath + "/api/EquipmentType/Update";
export const AddEquipmentType = MainPath + "/api/EquipmentType/Add";
export const DeleteEquipmentType = MainPath + "/api/EquipmentType/Delete";

export const allEquipment = MainPath + "/api/Equipment/getall";
export const editEquipment = MainPath + "/api/Equipment/Update";
export const AddEquipment = MainPath + "/api/Equipment/Add";
export const DeleteEquipment = MainPath + "/api/Equipment/Delete";

export const editItem = MainPath + "/api/Item/Update";
export const AddItem = MainPath + "/api/Item/Add";
export const DeleteItem = MainPath + "/api/Item/Delete";

export const editFactory = MainPath + "/api/Factory/Update";
export const AddFactory = MainPath + "/api/Factory/Add";
export const DeleteFactory = MainPath + "/api/Factory/Delete";

export const alluser = MainPath + "/api/User/getall";

export const Adduser = MainPath + "/api/User/Add";
export const Deleteuser = MainPath + "/api/User/Delete";

export const DeleteComplain = MainPath + "/api/complain/delete?id=";
export const DeleteContract = MainPath + "/api/contract/delete?id=";
export const DeleteWorkOrder = MainPath + "/api/workorder/delete?id=";

export const UsernameExists = MainPath + "/api/User/UsernameExists?username=";
export const EmailExists = MainPath + "/api/User/EmailExists?email=";
// ---------------------------Work Order Management page -------------------------

export const AllWorkOrdersDispature =
  MainPath + "/api/WorkOrder/GetAllSuborders";
export const AllWorkOrdersMovementController =
  MainPath + "/api/WorkOrder/GetByMovementController";
export const AvailableEquipmentInFactory =
  MainPath + "/api/Equipment/GetAvailableEquipmentInFactory?factoryId=";
export const UpdateAssignmentToWorkOrder =
  MainPath + "/api/Equipment/UpdateAssignmentToWorkOrder";
export const UpdateSubOrder = MainPath + "/api/WorkOrder/UpdateSubOrder";
export const reassinFactory =
  MainPath + "/api/WorkOrder/CanAssignToFactory?workorderId=";
export const AssignmentToFactory =
  MainPath + "/api/WorkOrder/UpdateOrderAssignmentToFactory?orderId=";
export const JobDetails = MainPath + "/api/job/GetByWorkOrder?workorderId=";
export const AvailableVehicleInFactory =
  MainPath + "/api/vehicle/GetAvailableVehicleInFactory?factoryId=";
export const AddJop = MainPath + "/api/job/add";
export const CancelJop = MainPath + "/api/job/Cancel?jobId=";
export const ReassignJop = MainPath + "/api/job/Reassign?jobId=";
export const AllWorkOrder = MainPath + "/api/WorkOrder/getall";
export const checkCustomerNameExist =
  MainPath + "/api/customer/IsCustomerNameExist?name=";
export const checkCustomerphoneExist =
  MainPath + "/api/customer/IsPhoneExist?phone=";
export const AllVehicles = MainPath + "/api/vehicle/getall";

export const NotificationOrders = MainPath + "/api/WorkOrder/getall";
export const RemindOrders = MainPath + "/api/WorkOrder/getall";

export const createUserUrl = "User/CreateUser";
export const updateUserUrl = "User/UpdateUser";
export const loginUrl = "User/Login";
export const ResetPasswordByToken = "User/ResetPasswordByToken";
export const loginManagementUrl = "UserManagementUser/Login";
export const submitLanguageUrlManagement = "UserManagementUser/SubmitLanguage";
export const submitExtensionUrlManagement = "UserManagementUser/SaveUserDeviceExtensionOfCallCenter";
export const getAllContractManagerUsers = "User/GetAll";
// export const submitLanguageUrl = "User/SubmitLanguage";
export const logoutUrl = "User/Logout";
export const getuserNameManagementByIdUrl =
  "UserManagementUser/GetUserNameById/";
export const getuserNameByIdUrl = "User/GetUserNameById/";
//////////////////////DataManagement/////////////////////////////////
//////////////Get/////////////
export const areasUrl = "Lang_Areas/GetAllLanguages";
export const areasPaginatedUrl = "Areas/GetAllPaginated";
export const attendanceStatusUrl = "Lang_AttendanceStates/GetAllLanguages";
export const availabilitysUrl = "Lang_Availability/GetAllLanguages";
export const availabilitysWithoutLangUrl = "Availability/GetAll";
export const buildingTypesUrl = "Lang_BuildingTypes/GetAllLanguages";
export const companyCodeUrl = "Lang_CompanyCode/GetAllLanguages";
export const contractTypesUrl = "Lang_ContractTypes/GetAllLanguages";
export const costCenterUrl = "CostCenter/GetAll";
export const divisionUrl = "Lang_Division/GetAllLanguages";
export const divisionEnUrl = "Division/GetAll";
export const governoratesUrl = "Lang_Governorates/GetAllLanguages";
export const shiftUrl = "Shift/GetAll";
export const languagesUrl = "SupportedLanguages/GetAll";
export const rolesUrl = "Role/GetAll";
export const adminUserUrl = "User/GetAdminUsers";
/////////////////// with block /////////////////
export const areasUrlWithBlocked = "Lang_Areas/GetAllLanguagesWithBlocked";
export const attendanceStatusUrlWithBlock =
  "Lang_AttendanceStates/GetAllLanguagesWithBlocked";
export const availabilitysUrlWithBlock =
  "Lang_Availability/GetAllLanguagesWithBlocked";
export const buildingTypesUrlWithBlock =
  "Lang_BuildingTypes/GetAllLanguagesWithBlocked";
export const companyCodeUrlWithBlock =
  "Lang_CompanyCode/GetAllLanguagesWithBlocked";
export const contractTypesUrlWithBlock =
  "Lang_ContractTypes/GetAllLanguagesWithBlocked";
export const costCenterUrlWithBlock = "CostCenter/GetAllWithBlocked";
export const divisionUrlWithBlock = "Lang_Division/GetAllLanguagesWithBlocked";
export const governoratesUrlWithBlock =
  "Lang_Governorates/GetAllLanguagesWithBlocked";
export const shiftUrlWithBlock = "Shift/GetAllData";
export const languagesUrlWithBlock = "SupportedLanguages/GetAllWithBlocked";
export const allProbsLocalizedWithBlock =
  "Lang_OrderProblem/GetAllLanguagesWithBlocked";
//export const getWorkingTypesWithBlock = 'WorkingType/GetAllGroupedWithBlocked';
export const getWorkingTypesWithBlock =
  "Lang_WorkingType/GetAllGroupedWithBlocked";
export const getOrderStatusWithBlock =
  "Lang_OrderStatus/GetAllOrderStatusWithBlocked";
//export const orderSubStatusWithBlock = 'OrderSubStatus/GetByStatusIdWithBlocked?id=';
export const orderSubStatusWithBlock =
  "Lang_OrderSubStatus/GetByStatusIdWithBlocked?id=";

/////////GetById///////////////
export const areaLanguageByIdUrl = "Lang_Areas/GetAllLanguagesByAreaId/";
export const attendanceStatesByIdUrl =
  "Lang_AttendanceStates/GetAllLanguagesByAttendanceStatesId/";
export const availabilityByIdUrl =
  "Lang_Availability/GetAllLanguagesByAvailabilityId/";
export const buildingTypesByIdUrl =
  "Lang_BuildingTypes/GetAllLanguagesByBuildingTypesId/";
export const companyCodeByIdUrl =
  "Lang_CompanyCode/GetAllLanguagesByCompanyCodeId/";
export const contractTypesByIdUrl =
  "Lang_ContractTypes/GetAllLanguagesByContractTypesId/";
export const CostCentersByIdUrl =
  "Lang_CostCenter/GetAllLanguagesByCostCenterId/";
export const divisionByIdUrl = "Lang_Division/GetAllLanguagesByDivisionId/";
export const governoratesByIdUrl =
  "Lang_Governorates/GetAllLanguagesByGovernorateId/";
export const ShiftByIdUrl = "Lang_Shift/GetAllLanguagesByShiftId/";
//OrderStatus
export const OrderStatusByIdUrl =
  "Lang_OrderStatus/GetAllLanguagesByOrderStatusId/";
//////////////Post/////////////
export const postPoblemUrl = "Lang_OrderProblem/Update";
export const postAreasUrl = "Areas/Add";
export const postAttendanceStates = "AttendanceStates/Add";
export const postAvailability = "Availability/Add";
export const postBuildingTypes = "BuildingTypes/Add";
export const postCompanyCode = "CompanyCode/Add";
export const postContractTypes = "ContractTypes/Add";
export const postCostCenter = "CostCenter/Add";
export const postDivision = "Division/Add";
export const postGovernorates = "Governorates/Add";
export const postShift = "Shift/Add";
export const postLanguages = "SupportedLanguages/Add";

export const postAreaLanguage = "Lang_Areas/AddMulti";
export const postAttendanceStatesLanguage = "Lang_AttendanceStates/AddMulti";
//OrderStatus
export const postOrderStatusLanguage = "Lang_OrderStatus/AddMulti";
export const postAvailabilityLanguage = "Lang_Availability/AddMulti";
export const postBuildingTypesLanguage = "Lang_BuildingTypes/AddMulti";
export const postCompanyCodeLanguage = "Lang_CompanyCode/AddMulti";
export const postContractTypesLanguage = "Lang_ContractTypes/AddMulti";
export const postCostCenterLanguage = "Lang_CostCenter/AddMulti";
export const postDivisionLanguage = "Lang_Division/AddMulti";
export const postGovernoratesLanguage = "Lang_Governorates/AddMulti";
export const postShiftLanguage = "Lang_Shift/AddMulti";

export const postOrdersManagementReport =
  "Order/GetOrderManagementReportPaginatedRefactored";
export const exportOrdersManagementReport =
  "Order/GetOrderManagementReportExportRefactored";

export const exportOrdersManagementReportToEmail =
  "Order/ExportingOrderMRReportToEmail";

//////////////put///////////
export const putAreasUrl = "Areas/Update";
export const putAttendanceStatesUrl = "AttendanceStates/Update";
export const putAvailabilityUrl = "Availability/Update";
export const putBuildingTypesUrl = "BuildingTypes/Update";
export const putCompanyCodeUrl = "CompanyCode/Update";
export const putContractTypesUrl = "ContractTypes/Update";
export const putCostCenterUrl = "CostCenter/Update";
export const putDivisionUrl = "Division/Update";
export const putGovernoratesUrl = "Governorates/Update";
export const putShiftUrl = "Shift/Update";
export const putLanguagesUrl = "SupportedLanguages/Update";

export const putAreaLanguageUrl = "Lang_Areas/UpdateAllLanguages";
export const putAttendanceStatesLanguageUrl =
  "Lang_AttendanceStates/UpdateAllLanguages";
export const putWorkingTypeLanguageUrl = "Lang_WorkingType/UpdateAllLanguages";
export const putOrderSubStatusLanguageUrl =
  "Lang_OrderSubStatus/UpdateAllLanguages";
//OrderStatus
export const putOrderStatusLanguageUrl = "Lang_OrderStatus/UpdateAllLanguages";
export const putAvailabilityLanguageUrl =
  "Lang_Availability/UpdateAllLanguages";
export const putBuildingTypesLanguageUrl =
  "Lang_BuildingTypes/UpdateAllLanguages";
export const putCompanyCodeLanguageUrl = "Lang_CompanyCode/UpdateAllLanguages";
export const putContractTypesLanguageUrl =
  "Lang_ContractTypes/UpdateAllLanguages";
export const putLang_CostCenterLanguageUrl = "CostCenter/Update";
export const putDivisionLanguageUrl = "Lang_Division/UpdateAllLanguages";
export const putGovernoratesLanguageUrl =
  "Lang_Governorates/UpdateAllLanguages";
export const putShiftLanguageUrl = "Lang_Shift/UpdateAllLanguages";
export const putProblemLanguageUrl = "Lang_OrderProblem/UpdateAllLanguages";

/////////////delete////////////////
export const deleteAreaUrl = "Areas/Delete/";
export const deleteAttendanceStatesUrl = "AttendanceStates/Delete/";
export const deleteAvailabilityUrl = "Availability/Delete/";
export const deleteBuildingTypesUrl = "BuildingTypes/Delete/";
export const deleteCompanyCodeUrl = "CompanyCode/Delete/";
export const deleteContractTypesUrl = "ContractTypes/Delete/";
export const deleteContractTypesUrlNew = "ContractTypes/DeleteContract?ids=";

export const deleteCostCenterUrl = "CostCenter/Delete/";
export const deleteDivisionUrl = "Division/Delete/";
export const deleteGovernoratesUrl = "Governorates/Delete/";
export const deleteShiftUrl = "Shift/Delete/";
export const deleteLanguagesUrl = "SupportedLanguages/Delete/";

export const deleteAreaLanguagesUrl = "Lang_Areas/Delete/";
export const deleteAttendanceStatesLanguagesUrl =
  "Lang_AttendanceStates/Delete/";
//OrderStatus
export const deleteOrderStatusLanguagesUrl = "Lang_OrderStatus/Delete/";

////////////// delete logical (block) ////////////////
export const blockArea = "Areas/LogicalDelete/";
export const blockAttendanceStatus = "AttendanceStates/LogicalDelete/";
export const blockAvailability = "Availability/LogicalDelete/";
export const blockBuildingType = "BuildingTypes/LogicalDelete/";
export const blockCompanyCode = "CompanyCode/LogicalDelete/";
export const blockContractType = "ContractTypes/LogicalDelete/";
export const blockCostCenter = "CostCenter/LogicalDelete/";
export const blockDivision = "Division/LogicalDelete/";
export const blockGovernorate = "Governorates/LogicalDelete/";
export const blockShift = "Shift/LogicalDelete/";
export const blockLanguage = "SupportedLanguages/LogicalDelete/";
export const blockProblem = "OrderProblem/LogicalDelete/";
export const blockWorkingType = "WorkingType/LogicalDelete/";
export const blockSubstatus = "OrderSubStatus/LogicalDelete/";
//OrderStatus
export const blockOrderStatus = "OrderStatus/LogicalDelete/";

///////////////////User Managent////////////////////
////////Get//////////
export const areasEnUrl = 'Areas/GetAll';
export const areasWithblocked = 'Areas/GetAllWithblocked';
export const getDispatcherUrl = 'Dispatcher/GetAll'
export const getDispatcherWithBlockedUrl = 'Dispatcher/GetAllWithblocked'
export const getDispatcherBySuperIdUrl = 'Dispatcher/GetDispatchersDataBySupervisorId/'
export const getDriverUrl = 'Driver/GetAll'
export const getICAgentUrl = '';
export const getSuperVisorUrl = 'Supervisor/GetAll'
export const getSuperVisorByDivisionIdUrl = 'Supervisor/GetSupervisorsDataByDivisionId/'
export const getEngineerUrl = 'Engineer/GetAll'
export const getEngineersByDivisionIdUrl = 'Engineer/GetEngineersByDivisionId /'
export const getTechnicianUrl = 'Technician/GetAll'
export const getAssignedTechnicianUrl = 'Technician/GetAllAssignedTechnicians'
export const getForemanUrl = 'Foreman/GetAll'
export const getManagerUrl = 'Manager/GetAll'
export const getMaterialUrl = 'Material/GetAll';
export const getAllFinanceUsers = 'FinanceUser/GetAllFinanceUsers';




export const getTeamsForForemen = 'Team/GetByFormanId'
export const getTeamsWithBlockedForForemen = 'Team/GetByFormansIdWithBlocked'
export const getTeamsWithBlockedForForemenasPostRequest = 'Team/GetByFormansIdWithBlockedAsPost'

// Roles And Permissions
export const getRolesAndPermissionsForFinance = 'RolesAndPermissions/GetFinanceRoles';
export const getRolesInCertainType = 'RolesAndPermissions/GetUserRolesByUserType?roleType=';

export const getRolesAndPermissionsForContractAdministrator = 'RolesAndPermissions/GetContractAdministratorRoles';

export const getRolesOfAdmin = 'RolesAndPermissions/GetAdminRoles';
export const GetAllRolesForEmailSettings = 'RolesAndPermissions/GetAllRolesForEmailSettings';

// Configurations values
export const GetAllConfigurationsSettings = 'ServioConfig/GetAll';


/////// get with block ///////
export const getDispatcherUrlWithBlock = "Dispatcher/GetAllWithBlocked";
export const getSupervisorUrlWithBlock = "Supervisor/GetAllWithBlocked";
export const getEngineerUrlWithBlock = "Engineer/GetAllWithBlocked";
export const getForemanUrlWithBlock = "Foreman/GetAllWithBlocked";
export const getTechnicianUrlWithBlock = "Technician/GetAllWithBlocked";
export const getManagerUrlWithBlock = "Manager/GetAllWithBlocked";
export const getMaterialUrlWithBlock = "Material/GetAllWithBlocked";
export const getContractAdministratorUrlWithBlock = 'ContractAdministratorUser/GetAllContractAdministratorUsers';

////// block /////////
export const blockDispatcher = "Dispatcher/Block/";
export const blockSupervisor = "Supervisor/Block/";
export const blockEngineer = "Engineer/Block/";
export const blockForeman = "Foreman/Block/";
export const blockTechnician = "Technician/Block/";
export const blockManager = "Manager/Block/";
export const blockMaterialController = "Material/Block/";
export const blockFinanceUser = "FinanceUser/Block/";
export const blockContractAdministratorUser = "ContractAdministratorUser/Block/";

/////////Post/////////////
export const postUserUrl = "User/Add";
export const postUserDispatcherUrl = "Dispatcher/Add";
export const postSupervisorUrl = "Supervisor/Add";
export const postDriverUrl = "Driver/Add";
export const postEngineerUrl = "Engineer/Add";
export const postTechnicianUrl = "Technician/Add";
export const postForemanUrl = "Foreman/Add";
export const postManagerUrl = "Manager/Add";
export const postMaterialControllerUrl = "Material/Add";
export const resetPassword = "User/ResetPassword";
export const addWorkingType = "WorkingType/Add";

//////////Update//////////////
export const putUserUrl = "User/Update";
export const putUserDispatcherUrl = "Dispatcher/Update";
export const putUserSupervisorUrl = "Supervisor/Update";
export const putUserDriverUrl = "Driver/Update";
export const putUserMangerUrl = "Manager/Update";
export const putUserMaterialControllerUrl = "Material/Update";
export const putUserEngineerUrl = "Engineer/Update";
export const putUserTechnicianUrl = "Technician/Update";
export const putUserForemanUrl = "Foreman/Update";

//////////////GetById///////////////
export const getDispatcherUserById = "Dispatcher/GetDispatcherUser/";
export const getSupervisorUserById = "Supervisor/GetSupervisorUser/";
export const getSupervisorUser = "Supervisor/Get/";
export const getSupervisorUserByUserId = "Supervisor/GetSupervisorByUserId/";
export const getDriverUserById = "Driver/GetDriverUser/";
export const getEngineerUserById = "Engineer/GetEngineerUser/";
export const getTechnicianUserById = "Technician/GetTechnicianUser/";
export const getForemanUserById = "Foreman/GetForemanUser/";
export const getFinanceUser = "FinanceUser/GetFinanceUser/";
export const getContractAdministratorUser = "ContractAdministratorUser/GetContractAdministratorUser/";
export const getMangerUserById = "Manager/GetManagerUser/";
export const getMateialControllerUserById =
  "Material/GetMaterialControllerUser/";
///////////GetByAnotherRole
export const getSupervisorUserBydivison =
  "Supervisor/GetSupervisorsByDivisionId/";
export const getEngineerUserBydivison =
  "Engineer/GetEngineerUsersByDivisionId/";
export const getDriverUserBydivison = "Driver/GetDriverUsersByDivisionId/";
export const getDispatchersUserBySuper =
  "Dispatcher/GetDispatcherUsersBySupervisorId/";
export const getFormanUserByDispatcher = "Foreman/GetForemansByDispatcherId/";

////////////////Identity/////////////////
export const getrUserById = "User/Get?id=";
export const checkUserNameExist = "User/IsUsernameExist";
export const checkUserPhoneExist = "User/IsPhoneExist";
export const checkUserEmailExist = "User/IsEmailExist";
export const deactivateUserByUsername = "User/ToggleActivation?username=";

///////////////////Team Management////////////////////////
/////////Get/////////
export const addVehicleURL = "Vehicle/Add";
export const updateVehicleURL = "Vehicle/Update";
export const getVehicleAllUrl = "Vehicle/GetAll";
export const getVehicleByPlateNoUrl = "TeamMember/SearchVec?word=";
export const getTechnicianByPFUrl = "TeamMember/SearchTech?word=";
export const getTeamByNameUrl = "Team/SearchByTeamName?word=";
export const getUnassignedVehiclesUrl = "TeamMember/GetUnassignedVehicleMember";
export const getUnassignedMempersUrl = "TeamMember/GetUnassignedMember";
export const getUnassignedMempersByDivisionIdUrl =
  "TeamMember/GetUnassignedMemberByDivisionId/";
export const getByDispatcherByIdUrl = "Team/GetByDispatcherId/";
export const getTeams = "Team/GetAllWithDispatcher";
export const getAllTeams = "Team/GetAll";
export const getAllTeamsWithOutMembers = "Team/GetAllTeams";
export const getMembersByTeamIdUrl = "TeamMember/GetMembersByTeamId/";

////////////Post///////////////
export const postTeam = "Team/Add";
export const updateTeam = "Team/Update";
export const assignTeamMember = "TeamMember/assignedMemberToTeam";
export const assignTeamMembers = "TeamMember/assignedMembersToTeam/";
export const reassignTeamToDispatcher = "Team/ReassignTeamToDispatcher";
export const unassignedMember = "TeamMember/UnassignedMember";
export const unassignedMembersURL = "TeamMember/UnassignedMembers";
export const postProblemArea = "DispatcherSettings/Add";

////////////delete/////////////////////
export const deleteTeamURL = "Team/Delete?teamId={id}";

////////////////////////Dispatcher Setting////////////
export const OrderProblem = "OrderProblem/GetAll";
export const OrderProblemWithBlocked = "OrderProblem/GetAllWithblocked";
export const disSettingUrl = "DispatcherSettings/GetAll";
export const GetMultiAreasAndProblemsbyDispatcherId =
  "DispatcherSettings/GetMultiAreasAndProblemsbyDispatcherId/{dispatcherId}";
export const getDispatcherSettingById =
  "DispatcherSettings/GetbyDispatcherId/{0}";
export const deleteDispatcherSetting = "DispatcherSettings/Delete/{0}";
export const disSettingUrls = "DispatcherSettings/Search";
export const postDispatcherAllProblemsandArea =
  "DispatcherSettings/AddWithMultiAreasAndOrderProblems";
export const UpdateMulitWithAreasAndOrderProblemsUrl =
  "DispatcherSettings/UpdateMulitWithAreasAndOrderProblems";
export const AddMulitWithAreasAndOrderProblemsUrl =
  "DispatcherSettings/AddWithMultiAreasAndOrderProblems";
export const getALLDispatcherSettingsListUrl =
  "DispatcherSettings/GetAllDispatchers";
export const getALLDispatcherSettingsbyGroupIdUrl =
  "DispatcherSettings/GetbyGroupId/{GroupId}";

//////////////////////OrderManagement/////////////////////////////////
//////////////Get/////////////
export const unAssignedOrdersForDispatcherUrl =
  "Order/GetUnAssignedOrdersForDispatcher?dispatcherId=";
export const unAssignedOrdersForDispatcherPaginatedUrl =
  "Order/GetUnAssignedOrdersForDispatcherPaginated";
export const unAssignedOrdersForDispatcherPaginatedFilterUrl =
  "Order/GetUnAssignedOrdersForDispatcherFilter";
export const assignedOrdersForDispatcherUrl =
  "Order/GetAssignedOrdersForDispatcher?dispatcherId=";
export const unAssignedOrdersForSupervisorUrl =
  "Order/GetUnAssignedOrdersForSupervisor?supervisrId=";
export const unAssignedOrdersForSupervisorFilteredPaginatedUrl =
  "Order/GetUnAssignedOrdersForSupervisorFilter";
export const assignedOrdersForSupervisorFilteredPaginatedUrl =
  "Order/GetAssignedOrdersForDispatchersBySupervisorFilter";
export const unAssignedOrdersForSupervisorPaginatedUrl =
  "Order/GetUnAssignedOrdersForSupervisorPaginated";
export const assignedOrdersForSupervisorUrl =
  "Order/GetAssignedOrdersForDispatchersBySupervisor?supervisorId=";
export const assigndOrdersToDispatcherUrl = "Order/AssignDispatcher";
export const unAssigndOrdersFromDispatcherUrl = "Order/UnAssignDispatcher";

export const getDispatcherFormensWithTeamsUrl = "Order/get-dispatcher-teams";
export const getTeamOrdersByTeamIdUrl = "Order/get-teams-orders";
export const assigndOrdersUrl = "Order/Assign";
export const unAssigndOrdersUrl = "Order/UnAssign";
export const rankTeamOrdersUrl = "Order/ChangeTeamRank";
export const rankTeamOrderskByDragUrl = "Order/ChangeTeamRankByDrag/true";
export const rankTeamOrdersWithoutNitificationUrl =
  "Order/ChangeOrderRankWithoutNotification";
export const orderDetailsUrl = "Order/Get/{ID}";
export const updateOrderUrl = "Order/UpdateAsync";
export const getAllPriorityUrl = "OrderPriority/GetAll";
export const getAllStatusUrl = "OrderStatus/GetAll";
export const getAllStatusWithBlockedUrl = "OrderStatus/GetAllWithblocked";
export const getCompanyCodeUrl = "CompanyCode/GetAll";
export const allDivisionsUrl = "Division/GetAll";
export const allDivisionsWithBlockedUrl = "Division/GetAllWithblocked";
export const allOrderTypesUrl = "OrderType/GetAll";
export const allOrderTypesWithBlockedUrl = "OrderType/GetAllWithblocked";
export const getPaciLocationUrl = "Paci/GetLocationByPaci?paciNumber=";
export const filterMapOrdersURL = "Order/OrderFilter";
export const orderSubStatus = "OrderSubStatus/GetByStatusId?id=";
export const updateOrderSubStatus = "OrderSubStatus/Update";
export const addOrderSubStatus = "OrderSubStatus/Add";
export const orderChangeStatus = "Order/ChangeStatus";
export const getFilteredOrdersForPrint = "Order/PrintOut";
export const getOrderByCode = "Order/GetOrderByCode?code=";
export const orderBulkAssign = "Order/BulkAssign";
export const searchOrderByCode = 'Order/searchByNumber/';
export const searchOrderByCodeNotCancel = 'Order/searchByNumberNotCanceled/';
export const GetOrderProfitReport = 'Order/GetOrderProfitReport/';
export const ExportOrderCostRevenueReport = 'Order/ExportOrderCostRevenueReport';


export const getAllStatusWithBlockedWithoutArchivedStatus = "OrderStatus/GetAllWithBlockedWithoutArchivedStatus";
////////////////////// time sheet //////////////////
export const TimeSheetUrlgetdate = "OrderAction/GetTimeSheet";
export const exportTimeSheetResultsUrl = "OrderAction/GetTimeSheetExcelExport";
export const exportTimeSheetResultsAsClosedXmlUrl = "OrderAction/GetTimeSheetExcelExportAsClosedXml";
export const exportingTimeSheetWayUrl = "OrderAction/ExportingTimeSheetWay";

//////////////////NotificationCenter //////////////////////

export const PostNotificationCenterURL =
  "NotificationCenter/GetByRecieverIdAndIsRead/";
export const GetNotificationCenterByIdURL = "NotificationCenter/Get/{id}";
export const GetNotificationCenterCountURL = "NotificationCenter/Count/";
export const PostNotificationCenterGetByIdsURL = "NotificationCenter/GetByIds";
export const GetAllNotificationCenterURL = "NotificationCenter/GetAll";
export const PutNotificationCenterItemURL = "NotificationCenter/Update/";
export const ChangeReadFlagNotificationCenterItemURL =
  "NotificationCenter/ChangeReadFlag/";
export const ChangeActionFlagNotificationCenterItemURL =
  "NotificationCenter/ChangeActionFlag/";
export const PostAddNotificationCenterURL = "NotificationCenter/Add";
export const PostAddMultiNotificationCenterURL = "NotificationCenter/AddMulti";
export const GetAllPaginatedNotificationCenterURL =
  "NotificationCenter/GetAllPaginated";
export const GetAllPaginatedByPredicateNotificationCenterURL =
  "NotificationCenter/GetAllPaginatedByPredicate";
export const DeleteNotificationCenterURL = "NotificationCenter/Delete/{id}";
export const GetNotificationCenterCountByRecieverIdURL =
  "NotificationCenter/CountByRecieverId/{recieverId}";
export const MarkAllAsReadByRecieverIdURL = "NotificationCenter/MarkAllAsRead/";
export const PutNotificationCenterChangeTeamOrderRankURL =
  "Order/ChangeOrderRank/{acceptChange}";
export const PostNotificationCenterFilteredByDate =
  "NotificationCenter/FilterByDate";
export const getAllNotificationCenterByTechAndOrderCode =
  "NotificationCenter/FilterByTechAndOrderCode";

///////////////map settings
export const getMapSettingsURL = "MapAdminRelated/Get/";
export const putMapSettingsURL = "MapAdminRelated/Update";

///////////////Working types
export const getWorkingTypes = "WorkingType/GetAllGrouped";
export const updateWorkingType = "WorkingType/Update";

//////////delete all
export const deleteAllOrders = "Order/DeleteAllOrders";
export const deleteAllDispatcherSettings =
  "DispatcherSettings/DeleteAllDispatcherSettings";
// important note about below api, when deleting all users from database,
// delete them from both user management api and identity api followed,
// by the below link
export const deleteAllManagementUsers = "UserManagementUser/DeleteAllUsers";
export const deleteAllUsers = "User/DeleteAllUsers";


///////////////////////////////////customerType
export const allCustomerTypesLang = "CustomerType/GetAllWithBlocked";
export const addCustomerTypeURL = "CustomerType/Add";
export const blockCustomerType = "CustomerType/LogicalDelete/";
export const putCustomerTypeLanguageUrl = "CustomerType/Update";
export const getAllCustomerTypeUrl = "CustomerType/GetAll";
export const getAllCustomerTypewithBlockUrl = "CustomerType/GetAllWithBlocked";


///////////////////////////////////machineType
export const allMachineTypesLang = "MachineType/GetAllWithBlocked";
//export const allMachineTypesLang = "Lang_MachineType/GetAllLanguagesWithBlocked";
export const addMachineTypeURL = "MachineType/Add";
export const blockMachineType = "MachineType/LogicalDelete/";
export const putMachineTypeLanguageUrl = "MachineType/Update";
export const getAllMachineTypeUrl = "MachineType/GetAll";

///////////////////////////////////PhoneType
export const allPhoneTypesLang = "Lang_PhoneType/GetAllLanguagesWithBlocked";
export const addPhoneTypeURL = "PhoneType/Add";
export const blockPhoneType = "PhoneType/LogicalDelete/";
export const putPhoneTypeLanguageUrl = "Lang_PhoneType/UpdateAllLanguages";

export const getAllPhoneTypeUrl = "PhoneType/GetAll";

////////////////////////////////////////Customer
export const allCustomersbyPaging = "customer/GetAllByPaging";
export const searchCustomersbyPaging = "customer/SearchCustomerData";
export const searchCustomersOfCallCenter = "customer/SearchCustomerOfCallCenter";

export const postCustomerUrl = "customer/Add";
export const getCustomerDetails = 'Customer/Get/';
export const updateCustomerUrl = 'Customer/UpdateCustomer';
export const getCustomerContracts = 'Customer/GetContractsOfCutomer/';
export const getCustomerContractInvoices = 'Customer/GetContractInvoicesOfCutomer/';
export const getCustomerContractUnits = 'Customer/GetContractUnitsOfCutomer/';
export const getCustomerAllContracts = 'Customer/GetAllContractsOfCutomer/';
export const getCustomerAllOrders = 'OrderNew/GetAllOrdersByCustomer/';
export const getContractDetails = 'Contract/Get/';
export const SearchAndGetAllCustomerAddress = "Customer/SearchAndGetAllCustomerAddress";
export const SearchAndGetAllCustomerAddressForOpportunity = "Opportunity/GetOpportunityAddress?OpportunityId=";
export const SearchAndGetAllCustomerAddressForMcPotential = "MCpotential/GetMCPotentialAddress?MCPotentialId=";
export const SearchAndGetAllCustomerAddressForQuotaion = "Quotations/GetQuotationLocations?QuotationId=";
export const getSearchCustomerAddressUrl = "Customer/SearchCustomerAddress";
export const getCustomerOrders = 'Customer/GetOrdersOfCutomer/';
export const GetContractAllUnitsOfCutomer = 'Customer/GetContractAllUnitsOfCutomer/';
export const viewOrderDetails = 'OrderNew/GetOrderDetailsById/';
export const CheckIfOrderCanBeAddedOrNot = 'OrderNew/CheckIfOrderCanBeAddedOrNot/';
export const viewOrderImages = 'OrderImages/GetOrderImagesForWeb/';
export const getOrderCompletedTasksGroupByProblem = 'PMTasks/GetOrderCompletedTasksGroupByProblem/';
export const getContractPreventiveTasks = 'PMTasks/GetContractPreventiveTasks?';
export const getOrderMaterialsInfo = 'OrderMaterial/GetAllMaterialGroupedBYSerialNoBYOrderId/';
export const getOrderMaterialsByOrderId = 'OrderMaterial/GetOrderMaterialsByOrderId/';
export const approvalOrderMaterial = 'OrderMaterial/ApprovalOrderMaterial/';
export const editOrderMaterials = 'OrderMaterial/EditOrderMaterials/';
export const sendOrderApprovalNotificationsToTechnician = 'OrderMaterial/SendOrderApprovalNotificationsToTechnician/';
export const searchCustomersReportbyPaging = "customer/SearchCustomerReport";
export const exportCuatomersReportUrl = "customer/ExportCustomerReport";
export const getCustomerAllMaterials = "OrderMaterial/GetAllCustomerServicesAndMaterials";
export const getCustomerAllInvoices = "ManualInvoice/GetAllCustomerInvoices";



export const AddCustomerAddress = "customer/AddCustomerAddress";
export const EditCustomerAddress = "customer/EditCustomerAddress";
export const SetAsPrimaryCustomerAddress = "customer/SetAsPrimaryCustomerAddress";
export const DeleteCustomerAddress = "customer/DeleteCustomerAddress/";




////////////////////////////////////Location Lookup
export const getAllGovUrl = "Governorates/GetAllWithBlocked";
export const getAreaByGovUrl = "Areas/GetAreasByGovId?GovId=";
export const getAreaByGovsUrl = "Areas/GetAreasByGovs";
export const GetAreasListByGovId = 'Areas/GetAreasListByGovId/';
export const getAllAreasUrl = "Areas/GetAreas";
//////////////////////////////////////phones Lookup
export const deleteCustomerPhoneBook = 'CustomerPhoneBook/Delete/';
export const deleteCustomerLocation = 'Customer/DeleteCustomerLocation/';






///////////////////////////////////UOMs
export const alUOMsLang = "UOMs/GetAllWithBlocked";
export const addUOMURL = "UOMs/Add";
export const blockUOM = "UOMs/LogicalDelete/";
export const putUOMLanguageUrl = "UOMs/Update";

//////////////////////////////////////////// Contract
export const allContractStatusForFilter = BaseUrlDataManagement + "ContractStatus/AllContractStatus";
export const allContractStatus = BaseUrlDataManagement + "Lang_ContractStatus/GetAllLanguagesWithBlocked";
export const postContractStatusLanguage = "Lang_ContractStatus/UpdateAllLanguages";
export const blockContractStatus = "ContractStatus/LogicalDelete/";
export const allContractStatusWithBlock = BaseUrlOrderManagementNew + "Lang_ContractStatus/GetAllLanguagesWithBlocked";
export const allContractStatusWithOutlanguage = BaseUrlDataManagement + "ContractStatus/AllPendingContractStatus";

//////////////////////////////////////////// Brands
export const AddBrand = "Brands/Add";
export const EditBrand = "Brands/Update";
export const blockBrand = "Brands/LogicalDelete/";
//export const BrandsList ="Brands/GetAllWithOrder";
export const BrandsList = "Brands/GetAllWithBlocked";

//////////////////////////////////////////// Serach Terms

export const EditSerachTerm = "SearchTerms/Update";
export const blockSerachTerm = "SearchTerms/LogicalDelete/";
//export const SerachTermsList = "SearchTerms/GetAllWithBlocked";
export const allSearchTermsListWithBlocked = BaseUrlDataManagement + "Lang_SearchTerms/GetAllLanguagesWithBlocked";
export const postSearchTermsLanguage = "Lang_SearchTerms/UpdateAllLanguages";
export const getSerachTermByIdUrl = "SearchTerms/Get/";
export const getSerachTermPaginatedIdUrl = "SearchTerms/GetSerachTermsValuePaginated";

////////////////////////////////////////////
export const getContractType = "ContractTypes/GetById/";

///////////////////////////////////Materials
//Groups
export const GroupsList = "Groups/GetAll";
export const allGroupsLang = "Groups/GetAllWithBlocked";
export const addGroup = "Groups/Add";
export const blockGroup = "Groups/LogicalDelete/";
export const putGroupLanguageUrl = "Groups/Update";
export const getMaterialIssueApprovalCycle = "MaterialIssueApprovalCycle/GetAllForGroup";

//SubGroups
export const allSubGroupsLang = "Lang_SubGroups/GetAllLanguagesWithBlocked";
export const addSubGroup = "SubGroups/Add";
export const blockSubGroup = "SubGroups/LogicalDelete/";
export const putSubGroupLanguageUrl = "Lang_SubGroups/UpdateAllLanguages";

///////////////////////////////////pmTasks
export const getPmTasksUrl = "Lang_PMTasks/GetAllLanguagesWithBlocked";
export const addPmTasksURL = "PMTasks/Add";
// export const blockPmTasksUrl = "PMTasks/LogicalDelete/";
// export const editPmTasksUrl = "PMTasks/Update";
export const getAllTasksGroupByProblem = "PMTasks/GetAllTasksGroupByProblem";

export const SerachTermsList = "SearchTerms/GetAllWithBlocked";

//////////////////////////////////////////// Materials
export const AddMaterial = "Materials/Add";
export const EditMaterial = "Materials/Update";
export const blockMaterial = "Materials/LogicalDelete/";
export const MaterialList = "Materials/GetMaterials";
export const LookUps = "Materials/GetLookUps";
export const subGroupsByGroupId = "Materials/GetSubGroupByGroupId?GroupId=";
export const getMaterial = "Materials/GetMaterialById?id=";
export const searchCustomersbyName = "customer/CustomerSearchByName";
export const getSearchTermsValues = "SearchTerms/GetSerachTermsValue";
export const addSearchTermValueUrl = "SearchTerms/AddValue";
export const deleteSearchTermValueUrl = "SearchTerms/RemoveValue/";
export const filterMaterialService = "Materials/SearchMaterialOrService";

/////////////////////////////// Services
export const AddService = "Services/Add";
export const EditService = "Services/Update";
export const blockService = "Services/LogicalDelete/";
export const ServiceList = "Services/GetServices";
export const getService = "Services/GetServiceById?id=";
export const exportService = "Services/ExportCSVTemplate"
export const importService = "Services/ImportServices"

//rchTerms/RemoveValue

export const ContractsGetPaginated = "Contract/GetPaginated";
export const GetPaginatedExpiredInAMonth = "Contract/GetPaginatedExpiredInAMonth";
export const searchContractByContractNumber = 'Contract/searchByNumber/'; // Json mocking


export const pendingContractsUrl = "Contract/GetPendingContracts";


export const approveContractsUrl = "Contract/Approve";
export const rejectContractsUrl = "Contract/Reject";
export const RemoveCancelationUrl = "Contract/RemoveCancelation";

export const ContractsLookUpsUrl = "Contract/GetLookUps";
export const AddContractUrl = "Contract/Add";
export const getContractByIdUrl = "Contract/GetContractById/";
export const getContractViewForManualInvoice = "Contract/GetContractViewForManualInvoice/";
export const GetContractDataByContractNumberForGeneratManualInvoiceUrl = "Contract/GetContractDataByContractNumberForGeneratManualInvoice/";


export const getContractCancelReasonsByIdUrl = "Contract/GetContractCacellationData?contractId=";
export const approveCancelSubmitedContractUrl = "Contract/Approve-Cancellation";
export const rejectCancelSubmitedContractUrl = "Contract/Reject-Cancellation";

export const getContractCustomerByIdUrl = "Customer/GetCustomerById/";
export const GetCustomerIdByPhone = "Customer/GetIdByPhone/";

export const canceleContractUrl = "Contract/Cancel";
export const getContractHistoryUrl = "Contract/GetContractProgress";
export const getContractCustomDataByIdUrl = "Contract/GetContractCustomData?contractId=";
export const getManualInoviceDetailByNumberUrl = "Contract/GetManualInvoiceDetails/";
export const updateCustomerDataUrl = "Customer/UpdateCustomerCode";
export const exportpendingContractsUrl = "Contract/ExportingPendingContracts";
export const exportContractExpireWithInMonth = "Contract/ExportingExpiredInAMonth";
export const exportAllContract = "Contract/ExportingAllContracts";
export const exportManualInvoicesUrl = "ManualInvoice/ExportingManualInvoice";

export const exportContractInvoicesUrl = "ContractInvoice/ExportingContractInvoice";

export const removeMachineUrl = "Contract/RemoveMachine";
export const removeCompressorUrl = "Contract/RemoveCompressor";
export const getContractInoviceDetailByNumberUrl = "ContractInvoice/GetContractInvoiceDetailes/";

export const archivedContractsGetPaginatedUrl = "Contract/GetArchivedPaginated";

// uploading
export const uploadFileUrl = "Upload/FilesUpload";
export const deleteFileUrl = "Upload/DeleleFile";

export const itemsByGroupId = "Materials/GetMaterilaByGroupId?GroupId=";


export const blockPmTasksUrl = "PMTasks/Block/";
export const editPmTasksUrl = "Lang_PMTasks/UpdateAllLanguages";


export const getAllpaymentsForInvoice = "ContractInvoicePayment/GetAllForInvoice/";
export const AddpaymentsForInvoice = "ContractInvoicePayment/Add/";
export const RemovePayments = "ContractInvoicePayment/RemovePayments";
export const AddManualInvoiceDiscount = "ManualInvoice/AddInvoiceDiscount";
export const AddContractInvoiceDiscount = "ContractInvoice/AddInvoiceDiscount/";

//////////////////////////////////////////////////////////// Order
export const addOrderUrl = "orderNew/AddOrder";
export const OnholdContract = "Contract/OnholdContract/";
export const RemoveOnHoldContract = "Contract/RemoveOnHold/";
export const RemoveOrderImage = "OrderImages/Delete/";

export const getAllOrderpaymentsForInvoice = "ManualInvoice/GetManualInvoiceWithOrder/";
export const AddOrderpaymentsForInvoice = "OrderInvoicePayment/Add/";
export const RemoveOrderPayments = "OrderInvoicePayment/RemovePayments/";


////////////////////////////////////Call Center
export const addCallCenterUser = "CallCenterUsers/Add";
export const editCallCenterUser = "CallCenterUsers/Update";
export const getCallCenterUserById = "CallCenterUsers/GetCallCenterUser/";
export const blockCallCenterUser = "CallCenterUsers/Block/";
export const getAllCallCenterUser = "CallCenterUsers/GetAllCallCenterUsers";
export const getAllCallCenterRoles = "RolesAndPermissions/GetCallCenterRoles";
export const getSupervisorCallCenterRoles = "RolesAndPermissions/GetSupervisorCallCenterRoles";

//////////////////////roels And Permissions
export const addRoleWithPermissions = "RolesAndPermissions/AddRole";
export const editRoleWithPermissions = "RolesAndPermissions/UpdateRole";
export const getAllRolesWithPermissions = "RolesAndPermissions/GetAllRolesByPaging";
export const getAllRoles = "RolesAndPermissions/GetAllRoles";

export const blockRoleWithPermissions = "RolesAndPermissions/LogicalDelete/";
export const getAllPermissionsGroupedByModule = "RolesAndPermissions/GetAllPermissionsGroupedByModule";
export const searchOrderUrl = "OrderNew/SearchOrderData";
export const searchTeamOrderUrl = "Team/FilterTeamOrderData";
export const preventiveMaintenanceReportUrl = "OrderNew/PreventiveMaintenanceReport";
export const exportPreventiveMaintenanceReportExcelUrl = "OrderNew/PreventiveMaintenanceReportExportExcel";
export const exportPreventiveMaintenanceReportPdfUrl = "OrderNew/PreventiveMaintenanceReportExportPdf";

export const getRoleWithPermissionsById = "RolesAndPermissions/GetRoleDetailsById/";
export const editContractUrl = "Contract/Update";
export const getContracByIdtUrl = "Contract/Get/";
export const getAllOrdersByPaging = "OrderNew/GetAllOrdersByPaging";
export const getAllGuestTempOrderPaging = "GuestTempOrder/GetAllByPaging";
export const GuestTempOrderGetById = "GuestTempOrder/Get/";
export const GetOrderIdByOrderGuestId = "GuestTempOrder/GetOrderIdByOrderGuestId/";




export const SearchGuestTempOrderByPaging = "GuestTempOrder/SearchByPaging";
export const GuestTempOrderAddOrderId = "GuestTempOrder/AddOrderId";
export const ExportGuestTempOrder = "GuestTempOrder/ExportingAllGuestOrders";

//call request
export const getAllCallRequestPaging = "CallRequest/GetAllByPaging";
export const SearchGuestCallRequestByPaging = "CallRequest/SearchByPaging";
export const ExportGuestCallRequestByPaging = "CallRequest/ExportingAllCallRequests";
export const CallRequestAddDoneBy = "CallRequest/AddDoneBy";
//end call request
export const viewOrderProgress = "OrderNew/ViewOrderProgress";
export const viewOrderInvoices = "OrderNew/GetContractInvoicesByOrderId";


//export const viewOrderProgress = "OrderNew/SearchOrderData";

//export const GetTaxPercentage = "Settings/GetTaxPercentage";
export const GetTaxPercentage = "GeneralSetting/GetTaxPercentage";



export const generateManualInvoiceUrl = 'ManualInvoice/Add'; // Json mocking
export const updateManualInvoiceUrl = 'ManualInvoice/Update'; // Json mocking
export const updateMAnualInvoicePaymentUrl = 'ManualInvoice/UpdateManualInvoicePayment';
export const getManualInvoiceById = 'ManualInvoice/Get/'; // Json mocking
export const getContractInvoiceById = 'ContractInvoice/Get/'; // Json mocking

export const getManualInvoiceByContractId = 'ManualInvoice/GetByContractId/'; // Json mocking
export const getManualInvoiceByCallId = 'ManualInvoice/GetByCallId/'; // Json mocking
export const getManualInvoiceByContractIdByPaging = 'ManualInvoice/GetByContractIdByPaging'; // Json mocking
export const getManualInvoiceByCallIdByPaging = 'ManualInvoice/GetByCallIdByPaging'; // Json mocking
export const updateManualInvoiceaAndDeleteUrl = 'ManualInvoice/UpdateManualInvoiceAndDelete';
export const getManualInvoiceByOrderId = 'ManualInvoice/GetByOrderId/';
export const getManualInvoiceByOrderIdByPaging = 'ManualInvoice/GetByOrderIdByPaging';
export const getAllManualInvoicesByPagingUrl = 'ManualInvoice/GetAllManualInvoicesByPaging/';
export const getAllContractInvoicesByPagingUrl = 'ContractInvoice/GetAllContractInvoicesByPaging/';
export const searchManualInvoiceData = 'ManualInvoice/SearchManualtInvoiceData';
export const manualInvoiceGetPaginated = 'ManualInvoice/GetPaginated';
export const manualInvoicecancelUrl = 'ManualInvoice/Cancel/';
export const DecriptyLinkForPayment = '/ManualInvoice/DecriptyLinkForPayment';
export const ManualInvoicePay = 'ManualInvoice/Pay/';
export const ManualInvoicePaymentVerify = 'ManualInvoice/PaymentVerify/';
export const GetAccessTokenForMerchant = 'ManualInvoice/GetAccessTokenForMerchant';
export const PayObjectOfPayment = 'ManualInvoice/PayObject/';

//manual invoices
export const allManualInvoiceUrl = 'ManualInvoice/GetPaginated';
export const allManualInvoiceExpiredUrl = 'ManualInvoice/GetPaginatedExpiredThisMonth';
export const manualInvoiceUpdateUrl = 'ManualInvoice/Update';
export const filterInvoiceDiscountUrl = "ManualInvoice/DiscountRequestPaginated";
export const orderDetailsDiscountUrl = "ManualInvoice/GetRequestDetailes";
export const approveRequestDiscountUrl = "ManualInvoice/ApproveDiscountRequest";
export const rejectRequestDiscountUrl = "ManualInvoice/RejectDiscountRequest";

export const getManualInvoiceWithPaymentUrl = 'ManualInvoice/GetManualInvoiceWithPayment/';
export const exportManualInvoiceWithPaymentUrl = 'ManualInvoice/ExportingManualInvoicePayment/';
//Contract Invoices
export const allContractInvoiceUrl = 'ContractInvoice/GetPaginated';
export const allContractInvoicesExpiredUrl = 'ContractInvoice/GetPaginatedExpiredThisMonth';
export const contractInvoiceUpdateUrl = 'ContractInvoice/Update';
export const assignedOrdersForForemanUrl = "Order/GetForemanBoardTeams?foremanId=";
export const contractInvoicecancelUrl = 'ContractInvoice/Cancel/';
export const deleteContractAddressUrl = "Contract/RemoveContractLocation";
export const addContractAddressUrl = "Contract/AddContractLocation";
export const getLocationsInContract = "Contract/GetLocationsInContract";
export const deleteContractUnitUrl = "Contract/RemoveUnit/";
export const renewContractUrl = "Contract/Renewal";
export const renewRejectedContractUrl = "Contract/RenewRejectedContract";

export const getRenewContractUrl = "Contract/ContractExpired";
export const getContractInvoiceWithPaymentUrl = 'ContractInvoice/GetContractInvoiceWithPayment/';
export const exportContractInvoiceWithPaymentUrl = 'ContractInvoice/ExportingContractInvoicePayment/';
export const getLocationsInContractPaged = "Contract/GetLocationsInContractPaged";


// general settings
export const PostGeneralSettingsURL = "GeneralSetting/Add";
export const SaveInvoiceSettings = "GeneralSetting/SaveInvoiceSettings";
export const SaveLabourSettings = "GeneralSetting/SaveLabourSettings";
export const GetGeneralSettingsURL = "GeneralSetting/GetGeneralSetting/";
export const GetCustomerSerialUrl = "GeneralSetting/GetCustomerSerialEnabled/";

//materials apis
export const allFreeRequestsUrl = "OrderMaterial/GetAllFreeRequests";
export const pendingFreeRequestsUrl = "OrderMaterial/GetPendingFreeRequests";
export const filterAllFreeRequestsUrl = "OrderMaterial/FilterAllFreeRequests";
export const filterPendingFreeRequestsUrl = "OrderMaterial/FilterPendingFreeRequests";
export const getAllApprovedUsersurl = "OrderMaterial/GetAllApprovedUsers";
export const exportMaterial = "Materials/ExportCSVTemplate"
export const importMaterial = "Materials/ImportMaterilas"
//OrderMaterial GetAllFreeRequests
export const saveMaterialApprovalCycleURL = "MaterialIssueApprovalCycle/Save";
export const getMaterialApprovalCycleURL = "MaterialIssueApprovalCycle/GetAllGroupByLevel";
export const getApprovalCycleRolesURL = "MaterialIssueApprovalCycle/GetRoles";
export const getCheckRoleValidToApprove = 'MaterialIssueApprovalCycle/CheckRoleValidToApprove/';

export const ContractsGetFilterPaginated = "Contract/ContractFilterPaginated";

export const pendingContractsFilterUrl = "Contract/GetPendingContractsFilter";
export const exportAllContractWithFilters = "Contract/ExportSearchContracts";

export const exportAllPendingContractWithFilters = "Contract/ExportSearchPendingContracts";
export const ForemanTeamOrdersUrl = "Order/get-foremanteams-orders";

//materials issue requests apis
export const getTeamIssueMaterialLight = "TeamMaterialTransaction/GetTeamIssueMaterialLight";
export const getAllTeamIssueMaterialLight = "TeamMaterialTransaction/GetAllTeamIssueMaterialLight";
export const allIssueRequestsUrl = "OrderMaterial/GetAllIssued";
export const pendingIssueRequestsUrl = "OrderMaterial/GetPendingIssued";
export const filterAllIssueRequestsUrl = "OrderMaterial/FilterAllIssuedRequest";
export const filterPendingIssueRequestsUrl = "OrderMaterial/FilterPendingIssued";
export const addTeamMaterialTransaction = "TeamMaterialTransaction/Add";
export const searchInIssueMaterialByPartNo = "TeamMaterialTransaction/SearchInIssueMaterialByPartNo";
export const getTeamIssueMaterial = "TeamMaterialTransaction/GetTeamIssueMaterial";
export const getFormanInDivision = "TeamMaterialTransaction/GetFormanInDivision/";

export const saveMaterialQtyUrl = "Materials/BulkUpdateQuantities";

export const getMaterialPricesOfDivisionUrl = "MaterialPrice/GetMaterialPricesOfDivision";
export const saveMaterialPricesUrl = "Materials/BulkUpdatePrice";
export const GroupsListForMaterial = "Materials/GetGroups";
export const partNumberMaterialUrl = "OrderMaterial/GetMaterialsPartNumbersIssuedToTeam";
export const exportingOrders = "OrderNew/ExportingOrders";
export const ExportingTeamOrders = "Team/ExportingTeamOrders";
export const ExportingTeamOrdersAsClosedXml = "Team/ExportingTeamOrdersAsClosedXml";

export const allOrderStatusUrl =
  BaseUrlOrderManagementNew + "OrderStatus/GetAllExcluded";
export const allOrderStatusUrl2 =
  BaseUrlOrderManagementNew + "OrderStatus/GetAll";
export const allReturnedRequestsUrl = "OrderMaterial/GetAllReturnMaterialRequests";


///////////////////////////////////Request Reasons
export const allRequestReasonsLangUrl = "Lang_RequestReason/GetAllLanguagesWithBlocked";
export const addRequestReasonURL = "RequestReason/Add";
export const blockRequestReasonUrl = "RequestReason/LogicalDelete/";
export const putRequestReasonLanguageUrl = "Lang_RequestReason/UpdateAllLanguages";
export const blockRequestReasonUrl2 = "RequestReason/BlockRequestReason/";

export const getAllOrderMaterialUrl = "OrderMaterial/GetOrderMaterialGroupedBYSerialNo";
export const searchMaterialByPartNo = "Materials/GetPartNos";
export const getAllOrderMachineUrl = "OrderMachine/GetAllMachinesInOrder";

//matrial report
export const filterMaterialReportUrl = "OrderMaterial/FilterMaterialReport";
export const exportMaterialReportUrl = "OrderMaterial/ExportMaterilaReport";
export const exportMaterilaReportAsClosedXmlUrl = "OrderMaterial/ExportMaterilaReportAsClosedXml";


export const getOrderMaterialApprovalDetailsUrl = "OrderMaterial/GetOrderMaterialApprovalDetailes";

//http://localhost:9999/api/ManualInvoice/GetRequestDetailes/19
//export const filterInvoiceDiscountUrl = "ManualInvoice/DiscountRequestPaginated";

export const allusersThatCreatedOrdersAsLookUps = "User/AllusersThatCreatedOrdersAsLookUps";

export const cancelRenewUrl = "Contract/RemoveDraft"

//Home dashboard
export const customerDataDashboardUrl = 'customer/GetAllCustomersForDashboard';
export const contractDataDashboardUrl = 'contract/SearchAllContractsWithStatusForDashboard'
export const OrderDataDashboardUrl = 'order/SearchAllOrdersWithStatusesForDashboard'
export const invoicesDataDashboardUrl = 'contractInvoice/GetAllInvoicesForDashboard'
export const TeamsOrdersDashboardUrl = 'order/SearchCompletedAndOngoingOrdersOfTeamForDashboard'
export const DispatcherOrdersDashboardUrl = 'order/SearchAllOrdersForDispatcherDashboard'
export const UsersOrdersDashboardUrl = 'order/SearchAllOrdersForCallCenterDashboard'


//dash board
export const customerDashboardUrl = 'customer/CsutomerForDashboard';
export const contractDashboardUrl = 'contract/SearchContractsForDashboard'
export const OrderDashboardUrl = 'order/SearchOrdersForDashboard'
export const OrderByDispDashboardUrl = 'order/SearchOrdersByDispForDashboard'
export const OrderByTeamDashboardUrl = 'order/SearchOrdersByTeamForDashboard'
export const invoicesDashboardUrl = 'contractInvoice/SearchInvoicesForDashboard'
export const GetAllMachinesByUnit = 'OrderNew/GetAllMachinesByUnitId/';
export const getSubgroupbygroupIdsUrl = "Materials/GetSubgroupbygroupIds";
export const SearchMaterialsUrl = "Materials/GetMaterials";

//tags
export const addTagUrl = "Tag/Add";
export const editTagUrl = "Tag/Update";
export const blockTagUrl = "Tag/LogicalDelete/";
export const getAllTagsUrl = "Lang_Tag/GetAllLanguagesWithBlocked";
export const saveTagsUrl = "Lang_Tag/UpdateAllLanguages";
export const AllEmailSettingGrouped = 'EmailSetting/GetAllEmailSettingGrouped';
export const AddWithMultiEmailSettings = 'EmailSetting/AddWithMultiEmailSettings';

export const gettagsUrl = "Tag/GetAllTags";
export const postUnitTagUrl = "UnitTag/AddUnitTags";
export const getUnitTagUrl = "UnitTag/UnitTags/";
export const deleteUnitTagUrl = "UnitTag/RemoveUnitTags";
export const deleteAllUnitTagUrl = "UnitTag/RemoveAllUnitTags";
export const getCustomerUnitTagedUrl = "UnitTag/CustomerUnitTags/";

export const unTagUnitUrl = "UnitTag/UnTagUnit";
//export manual invoice details
export const exportManualInvoiceDetailsUrl = "Contract/ExportingManualInvoiceDetails/";
//export contract invoice details
export const exportContractInvoiceDetailsUrl = "ContractInvoice/ExportingContractInvoiceDetails/";

export const WarehouseMaterialsRequestsUrl = "OrderMaterial/GetAllWarehouseMaterials";
export const filterWarehouseMaterialsRequestsUrl = "OrderMaterial/FilterWarehouseMaterials";
export const getOrcalMaterialsCountUrl = "OrderMaterial/GetAllWarehouseMaterialsCount";
export const filterWarehouseMaterialsRequestsUrlSTS = "STSRequests/Filter";
export const getSTSReturnCountsUrl = "STSRequests/FilterCount";
export const getSTSReturnMaterialsUrl = "STSRequests/GetSTSRequestsByOrderId?orderId=";

export const saveStsApprovalCycleURL = "StoreToServiceApprovalCycle/Save";

export const getStsApprovalCycleURL = "StoreToServiceApprovalCycle/GetAllGroupByLevel";
export const getSTSApprovalCycleRolesURL = "StoreToServiceApprovalCycle/GetRoles";


export const approveStsRequestURL = "STSRequests/ApprovalSTSRequest";

export const sendStsRequestToTechURL = "STSRequests/SendSTSRequestsNotificationsToTechnician";



export const editStsRequestURL = "STSRequests/EditSTSRequest";

export const stsrequestsLocatorsUrl = "STSRequestLocators/GetAll";
export const stsRequestsInventoryOrganizationUrl = "STSRequestInventoryOrganizations/GetAll";
export const stsRequestsAccountNumbersUrl = "STSRequestAccountNumbers/GetAll";
export const stsRequestsSubInventoryCodesUrl = "STSRequestSubinventoryCodes/GetAll";
export const stsRequestsTrainSourcesUrl = "STSRequestTRAN_SOURCEs/GetAll"
export const stsCheckRoleValidToApproveUrl = 'StoreToServiceApprovalCycle/CheckRoleValidToApprove/';




export const getRequestDiscountCountUrl = "ManualInvoice/DiscountRequestCount";

// customer tags apis
export const getCustomerTagedUrl = "CustomerTag/CustomersTags/";
export const postCustomerTagUrl = "CustomerTag/AddCustomerTags";
export const deleteAllCustomerTagsUrl = "CustomerTag/RemoveAllCustomerTags";
export const deleteCustomerTagUrl = "CustomerTag/RemoveTag";
export const exportAllContractInvoiceUrl = 'ContractInvoice/ExportingContractInvoiceList';
export const exportAllManualInvoiceUrl = 'ManualInvoice/ExportingManualInvoicesList';
export const ordersReport = "OrderNew/PrintServiceOrder";

export const allCustomerAddressesByPaging = "customer/CustomerAddressPaginated";
//paid/unpaid invoices apis
export const getAllPaidInvoicesUrl = "ManualInvoice/PaidAndUnPaidInvoices";
export const exportPaidInvoicesUrl = "ManualInvoice/ExportingPaidAndUnPaidInvoices";

//ManualInvoice/PaidAndUnPaidInvoices

//get orders for calendar
export const getAllOrders = 'OrderNew/SearchOrderForCalendar/';

//terms and conditions
export const getAllTermsUrl = 'TermsAndConditions/GetAll'
export const updateTermsUrl = 'TermsAndConditions/Update'
export const AddTermsUrl = 'TermsAndConditions/Add'
export const GetByContractTypeId = 'TermsAndConditions/GetByContractTypeId'
export const allFreeRequestsCountUrl = "OrderMaterial/GetAllFreeRequestsCount";

//customer contracts apis
export const getAllCustomerContractsUrl = 'CustomerContract/GetCustomerContract/';
export const getContractInvoicesUrl = 'CustomerContract/GetContractInvoices?contractNo=';
export const getForemanGetAllWithParentIdsDto = "Foreman/GetAllWithParentIdsDto";
export const getTeamGetAllWithParentIdsDto = "Team/GetAllWithParentIdsDto";
export const getDispatcherGetAllAsLookUp = "Dispatcher/GetAllAsLookUp";
export const getOrderMaterialGetAllPaginatedForReport = "OrderMaterial/GetAllPaginatedForReport";
export const getOrderMaterialGetAllExportForReport = "OrderMaterial/GetAllExportForReport";
export const getAllContractChildsUrl = 'CustomerContract/GetContractChilds/';
export const allIssueRequestsCountUrl = "OrderMaterial/GetAllIssueRequestsCount";
export const allContractAddressesByPaging = "Contract/GetContractAddressPaginated";
export const getTeamsByProblemId = 'Team/TeamsGetByProblemId/';
export const getAllTeamsAsLookUpUrl = "Team/GetTeams";
export const GetAllExportForReportAsCloseXml = "OrderMaterial/GetAllExportForReportAsCloseXml";


// company profiles apis
export const getCompanyProfileUrl = "CompanyProfileSetting/GetDefault";
export const saveCompanyProfileUrl = "CompanyProfileSetting/SaveDefault";
//
export const getContractTypeSettingsUrl = 'MasterContractTypeSetting/GetContractTypeSettings/';
export const saveContractTypeSettingsUrl = 'MasterContractTypeSetting/BulkContractTypeSettings';
export const getAllContractTypeSettingsUrl = 'MasterContractTypeSetting/GetAllContractTypeSettings';
export const unassignMaterialTransaction = "TeamMaterialTransaction/UnAssignMaterialToTeam";
export const teamAutoCompleteUrl = "Team/searchByName/";

export const deleteFileActualDEleting = "ContractFiles/DeleteFile/";

//invoices report 
export const getInvoicesReportUrl = "ManualInvoice/InvoicesReport";
export const getOnlinePaymentsUrl = "ManualInvoice/InvoicesPaymentReport";
export const exportOnlinePaymentsUrl = "ManualInvoice/ExportingInvoicesPaymentReport";
export const exportInvoicesReportUrl = "ManualInvoice/ExportingInvoicesReport";
export const getInvoiceDetailesReportUrl = "ManualInvoice/InvoiceDetailesReport";
export const getInvoiceDetailesReportExportUrl = "ManualInvoice/InvoiceDetailesReportExport";
export const getInvoiceDetailesReportExportAsCloseXmlUrl = "ManualInvoice/InvoiceDetailesReportExportAsClosedXML";

//quotations PriceList apis
export const addPriceListUrl = "UnitPrice/AddUnitPriceList";
export const editPriceListUrl = "UnitPrice/UpdateUnitPrice";
export const getPriceListSettingsUrl = "UnitPriceSetting/GetUnitPriceSetting";
export const listPriceListsUrl = "UnitPrice/GetUnitPrices";
export const contractTypesListUrl = "UnitPrice/GetContractTypesList";
export const getPriceListByIdUrl = "UnitPrice/Get/";
export const getPriceByHpUrl = "UnitPrice/GetPriceForHpAndQuantity";


// UpdateUnitPrice
export const addLeadUrl = "Lead/Add";
export const editLeadUrl = "Lead/Update";
export const getLeadByIdUrl = "Lead/GetLead/";
export const getAllLeadsUrl = "Lead/GetLeadsFiltered";
export const getAllLeadGoalsUrl = "LeadGoal/AllLeadGoals";
export const convertToOpportunityUrl = "Lead/ConvertToOpportunity";
export const convertToMcUrl = "Lead/ConvertLeadToMc";
export const getLeadDetailsByIdUrl = "Lead/GetLeadDetailes/";
export const exportingLeadsUrl = 'Lead/ExportingLeads';
// Opportunity apis

export const addOpportunityUrl = "Opportunity/Add";
export const editOpportunityUrl = "Opportunity/Update";
export const getOpportunityByIdUrl = "Opportunity/GetOpportunity/";
export const getAllOpportunitiesUrl = "Opportunity/GetLOpportunityFiltered";
export const convertOpportunityToMcUrl = "MCpotential/ConvertOpportunityToMc";
export const getOpportunityDetailsUrl = "Opportunity/GetOpportunityDetailes/";
export const exportingOpportunitiesUrl = 'Opportunity/ExportingOpportunities';
// Quotations  apis
export const getSalesUsersUrl = "Quotations/GetSalesUsers";
export const getTermsAndConditionsUrl = "TermsAndConditions/Get/";
export const addQuotationUrl = "Quotations/AddQuotation"
export const getQuotationSettingUrl = "InvoiceSetting/GetQuotationSetting";
export const getAllQuotationsUrl = "Quotations/GetAllQuotations";
export const getAllPendingQuotationsUrl = "Quotations/GetPendingQuotations";
export const getAllExpiredQuotationsUrl = "Quotations/GetExpiredWithInMonthQuotations";
export const getPendingQuotationsCountUrl = "Quotations/GetPendingQuotationsCount";
export const getQuotationByIdUrl = "Quotations/Get/";
export const updateQuotationUrl = "Quotations/UpdateQuotation";
export const cancelQuotationUrl = "Quotations/Cancel";
export const convertMcToQuotationUrl = "Quotations/ConvertMcToQuotation";
export const convertOpportunityToQuotationUrl = "Quotations/ConvertopportunityToQuotation";
export const getLocationsInQuotation = "Quotations/GetLocationsInQuotation";
export const deleteQuotationAddressUrl = "Quotations/RemoveQuotationLocation";
export const addQuotationAddressUrl = "Quotations/AddQuotationLocation";

export const convertQuoationToContractUrl = "Contract/ConvertQuotationToContract";
export const submittQuotationUrl = "Quotations/SubmittQuotation";
// mc potential apis McPotential

export const addMcPotentialUrl = "MCpotential/CreatePotential";
export const editMcPotentialUrl = "MCpotential/Update";
export const getMcPotentialByIdUrl = "MCpotential/GetMcPotential/";
export const getAllMcPotentialsUrl = "MCpotential/GetMCpotentialFiltered";
export const addMcOrderUrl = "MCpotential/Add";
export const editMcOrderUrl = "MCpotential/Update";
export const getMcPotentialDetailsByIdUrl = "MCpotential/GetMcPotentialDetailes/";
export const exportingMcPotentialUrl = 'MCpotential/ExportingMcPotential';

//export quotations url
export const exportExpiredQuotationsUrl = "Quotations/ExportingExpiredInAMonth";
export const exportAllQuotationsUrl = "Quotations/ExportingAllQuotations";
export const exportPendingQuotationsUrl = "Quotations/ExportingPendingQuotations";
//Quotations history
export const getQuotationHistoryUrl = "QuotationsWorkFlow/GetQuotationWorkflow";


/// leads
export const allLeadsLang = "Lang_LeadGoal/GetAllLanguagesWithBlocked";
export const addLeadGoalURL = "LeadGoal/Add";
export const blockLeadGoal = "LeadGoal/LogicalDelete/";
export const putLeadGoalLanguageUrl = "Lang_LeadGoal/UpdateAllLanguages";

//export const getAllLeadGoalsUrl = "Lang_LeadGoal/GetAll";



export const getTasksByProblemUrl = "PMTasks/GetAllTasksByProblemId";
export const saveTasksProblemOrderUrl = "PMTasks/SaveCompltedOrderTasks";
export const getOrderCompletedTasksUrl = 'PMTasks/GetOrderTasksGroupByProblem/';
export const getOrderProblemsUrl = 'OrderProblem/GetAllProblemsWithFlagUsedInOrders/';
export const updateOrderCompletedTasksUrl = 'PMTasks/UpdateOrderCompletedTasks/';
export const updateOrderSurveyReportUrl = 'OrderNew/UpdateOrderSurvyReports';
export const getQuotationDataByIdtUrl = "Contract/InitaiteConvertQuotationToContract/";
//getAllPendingMaterialsCountUrl
export const getAllPendingMaterialsCountUrl = "OrderMaterial/GetPendReturnedMaterialCount";
export const addMultiQuotationDiscount = "QuotationApprovalCycle/AddMultiQuotationDiscount";
export const getAllQuotationApprovalDiscounts = "QuotationApprovalCycle/GetAllQuotationApprovalDiscounts/";
//api/Quotations/GetSalesUsers
export const rejectQuotationUrl = "Quotations/Reject";
export const approveQuotationUrl = "Quotations/Approve";
// export const uploadImportMaterialUrl = "Quotations/Reject";
export const uploadImportServicesUrl = "Services/UploadImportFiles";

export const uploadImportMaterialUrl = 'Materials/UploadImportFiles';
export const getAllApprovedUsersurlForSTSRequests = "STSRequests/GetAllApprovedUsers";

export const getCustomerDeleteRequestsUrl = "UserRquest/GetRequestDeleteCustomers";
export const approveDeleteCustomerRequestUrl = "UserRquest/ApproveDisapproveDeleteCustomerRequest";
export const rejectDeleteCustomerRequestUrl = "UserRquest/RejectDisapproveDeleteCustomerRequest";
export const getContractCustomDataAddingOrderByIdUrl = "Contract/GetContractCustomDataAddOrder?contractId=";
// exporting large files
export const exportingOrdersToEmail = "OrderNew/ExportingOrdersToEmail";
export const getByIdWithEmail = "User/GetByIdWithEmail?id=";
export const editEmailUrl = "User/EditEmail";
export const exportingCustomerReportToEmail = "Customer/ExportingCustomerReportToEmail";
export const exportingContractsReportToEmail = "Contract/ExportingContractsToEmail";
export const exportingContractsReportExcelToEmail = "Contract/ExportingContractsAsCloseXmlToEmail";
export const exportingPendingContractsReportToEmail = "Contract/ExportingPendingContractsToEmail";
export const exportingPendingContractsReportToEmailAsCloseToXml = "Contract/ExportingPendingContractsToEmailAsCloseToXml";

export const exportingSearchPendingContractsCloseXmlReportToEmail = "Contract/ExportSearchPendingContractsAsCloseXmlToEmail";

export const exportingContractsWay = "Contract/ExportingAllContractsWay";
export const exportingPendingContractsWay = "Contract/ExportingPendingContractsWay";
export const exportingCustomersReportWay = "Customer/ExportingCustomersReportWay";
export const exportingOrdersReportWay = "OrderNew/ExportingOrdersWay";
export const exportingExpireWithInMonthContractsReportWay = "Contract/ExportingExpireWithInMonthContractsWay";
export const exportingExpireWithInMonthContractsReportToEmail = "Contract/ExportingExpireWithInMonthContractsToEmail";
export const exportingManualInvoicesWay = "ManualInvoice/ExportingManualInovicesWay";
export const exportingManualInvoicesToEmail = "ManualInvoice/ExportingManualInvoicesToEmail";
export const exportingManualInvoicesToEmailAsClosedXML = "ManualInvoice/ExportingManualInvoicesToEmailAsClosedXML";

export const exportingContractInvoicesWay = "ContractInvoice/ExportingContractInovicesWay";
export const exportingContractInvoicesToEmail = "ContractInvoice/ExportingContractInvoicesToEmail";

export const exportingPaidAndUnPaidInvoicesWay = "ManualInvoice/ExportingPaidAndUNPaidnovicesWay";
export const exportingPaidAndUnPaidInvoicesToEmail = "ManualInvoice/ExportingPaidAndUnpaidInvoicesToEmail";

export const exportingExpirednovicesWay = "ManualInvoice/ExportingExpirednovicesWay";
export const exportingExpiredInvoicesToEmail = "ManualInvoice/ExportingExpiredInvoicesToEmail";

export const exportingContractInvoicesExpiredWay = "ContractInvoice/ExportingContractInovicesExpiredWay";
export const exportingContractInvoicesExpiredToEmail = "ContractInvoice/ExportingContractInvoicesExpiredToEmail";
export const exportingContractInvoicesAsCloseXmlToEmail = "ContractInvoice/ExportingContractInvoicesAsCloseXmlToEmail";

export const printQuotationUrl = "Quotations/PrintQuotation/";
export const exportingSearchContractsReportToEmail = "Contract/ExportingSearchContractsToEmail";
export const exportingSearchContractsAsCloseXMLReportToEmail = "Contract/ExportingSearchContractsAsCloseXmlToEmail";

export const exportingOrdersAsCloseXmlToEmail = "OrderNew/ExportingOrdersAsCloseXmlToEmail";
export const exportingPaidAndUnPaidInvoicesAsXmlToEmail = "ManualInvoice/ExportingPaidAndUnpaidInvoicesAsXmlToEmail";


export const exportingSearchContractsWay = "Contract/ExportingSearchContractsWay";
export const exportingSearchPendingContractsReportToEmail = "Contract/ExportSearchPendingContractsToEmail";
export const exportingSearchPendingContractsWay = "Contract/ExportSearchPendingContractsWay";
export const updatePreventiveMaintanceOrders = "Order/UpdatePreventiveMaintanceOrders";
export const printContractURl = "Contract/PrintContract";
////////////////paymentGateway

export const PaymentGateWayGenerateLink = "PaymentGateway";
export const GetByEncryptedId = "PaymentGateway/GetByEncryptedId";
export const PaymentGateWayPay = "PaymentGateway/Pay";
export const PaymentGateWaysuccess = "PaymentGateway/success";
export const TapPaymentRedirect = "PaymentGateway/TapPaymentRedirect";

export const sendEmail = "EMail/Send";
export const sendSms = "Sms/Send";
export const PGGetFiltedReport = "PaymentGateway/PGGetFiltedReport";
export const ExportingPGWay = "PaymentGateway/ExportingPGWay";
export const ExportingPGToEmail = "PaymentGateway/ExportingPGToEmail";
export const ExportingExcelPGToEmailAsCloseXML = "PaymentGateway/ExportingExcelPGToEmailAsCloseXML";


export const deletePaymentTransactionUrl = 'PaymentGateway/DeletePaymentTransaction/';

export const getReportLookUps = "Contract/GetReportLookUps";
export const getContractContractsRevenueAllocation = "Contract/GetContractContractsRevenueAllocation";
export const exportingContractsRevenueAllocationToEmail = "Contract/ExportingContractsRevenueAllocationToEmail";
export const exportingContractsRevenueAllocationAsClosedXmlToEmail = "Contract/ExportingContractsRevenueAllocationAsClosedXmlToEmail";
export const exportingContractsRevenueAllocationWay = "Contract/ExportingContractsRevenueAllocationWay";
export const getAllTeamIssueMaterial = "TeamMaterialTransaction/GetAllTeamIssueMaterial";
export const postCustomerFromWebUrl = "customer/AddCustomerFromWeb";

export const getInventoryTransactionsUrl = "InventoryTransactions/GetInventoryTransactionReport";
export const exportInventoryTransactionsWayUrl = "InventoryTransactionsExport/InventoryTransactionReportExportWay";
export const exportInventoryTransactionsToEmailUrl = "InventoryTransactionsExport/InventoryTransactionReportExportToEmail";
export const exportInventoryTransactionsAsClosedXmlToEmailUrl = "InventoryTransactionsExport/InventoryTransactionReportExportAsClosedXmlToEmail";
export const getUserExportedFilesUrl = "ExportedFiles/GetUserExportedFiles";
export const getAllContractChildsWithPaginationUrl = 'CustomerContract/GetContractChildsWithPagination/';

export const shiftGetAllUrl = "Shift/GetAllData";
export const deleteFilesUrl = "ExportedFiles/DeleteFile/";

export const getContractAddressUrl = "Contract/GetContractAddress?contractId=";
export const addPreventiveManitanceToContractUrl = "Contract/AddPreventiveMaintenance";
export const getUnitReports = "UnitReport/GetReportData";
export const getSelectedReport = "UnitReport/GetMachineData"
export const exportUnitReport = "UnitReport/ExportUnitMachines"
export const UpdateUnitMachines = "UnitReport/UpdateUnitMachines"
export const ExportUnitMachinesAsCloseXML = "UnitReport/ExportUnitMachinesAsCloseXML"


// My Subscription (External Billing System)
export const getSubscriptionSummaryUrl = 'Subscription/GetSummary';
export const getSubscriptionInvoicesUrl = 'Subscription/GetInvoices?pageNo=';
export const getSubscriptionInvoiceUrl = 'Subscription/GetInvoice/';
export const getSubscriptionPaymentLinkUrl = 'Subscription/GetPaymentLink/';
export const downloadSubscriptionInvoiceUrl = 'Subscription/DownloadInvoice/';
export const getSubscriptionPaymentHistoryUrl = 'Subscription/GetPaymentHistory';
export const downloadSubscriptionStatementUrl = 'Subscription/DownloadStatement';
